import { render, staticRenderFns } from "./VStepTab.vue?vue&type=template&id=98e93648&"
import script from "./VStepTab.vue?vue&type=script&lang=js&"
export * from "./VStepTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports